import { useRef, memo } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';

export const VirtualizedLogList = memo(({ items, renderItem }: { items: any[], renderItem: (item: any, index: number) => React.ReactNode }) => {
  const parentRef = useRef<HTMLDivElement>(null);

  const rowVirtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 48, // A reasonable estimate
    overscan: 5,
  });

  return (
    <div ref={parentRef} className="max-h-[40vh] overflow-y-auto pr-2">
      <div style={{ height: `${rowVirtualizer.getTotalSize()}px`, width: '100%', position: 'relative' }}>
        {rowVirtualizer.getVirtualItems().map(virtualItem => {
          const item = items[virtualItem.index];
          return (
            <div
              key={virtualItem.key}
              data-index={virtualItem.index}
              ref={rowVirtualizer.measureElement}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                transform: `translateY(${virtualItem.start}px)`,
              }}
            >
              {renderItem(item, virtualItem.index)}
            </div>
          );
        })}
      </div>
    </div>
  );
});
